<template>
    <rkm-overlay>
        <rkm-layout-body title="Mapa do dia">
            <rkm-layout-content v-if="loaded">
                <Form
                    :data="{ form }"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import Form from '@/components/exame-laboratorial/mapa-dia/Form'

import { mapActions } from 'vuex'
import { repository, error, object, data } from '@/mixins'

export default {
    components: { Form },
    created() {

        this.repositories = {
            mapaProducao: this.getConectaSusRepository('exameLaboratorial.mapaDia')
        }

        this.load()
    },
    data: () => ({
        loaded: false,
        form: {},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.mapaProducao.create()
                .then(({ data }) => {

                    this.form = data.form
                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [repository, error, object, data]
}
</script>